export const environment = {
  production: false,
  apiUrl: 'http://192.168.1.93:44300/api',
  mediaPlanApiUrl: 'http://192.168.1.93:44301/api/MPGateway',
  abortUrl: 'http://192.168.1.93:44301/api/MPBrowserAbort',
  reportGateway: 'http://192.168.1.93:44382/api/Report',
  pregledVerifikacijaUrl: 'http://192.168.1.93:44502/kalendar',
  verifikacijaUrl: 'http://192.168.1.93:44502/Verifikacija',
  kopijaVerifikacijeUrl: 'http://192.168.1.93:44502/Verifikacija2',
  sacuvajVerifikaciju: 'http://192.168.1.93:44502/api/sacuvajVerifikaciju',
  pregledObracunaUrl: 'http://192.168.1.93:44522/PregledObracuna',
  nepriznataEmitovanja: 'http://192.168.1.93:44522/PregledNeobracunatihStavki',
  pregledPodugovoraZaObracunUrl:
    'http://192.168.1.93:44522/PodugovorZaObracunList',
  fakturisanjeUrl: 'http://192.168.1.93:44551/Fakturisanje',
  pregledFakturaUrl: 'http://192.168.1.93:44551/FaktureListForm',
  ariannaUrl: 'http://192.168.1.93:4397/Kalendar',
  ariannaGledanostEmisijeUrl: 'http://192.168.1.93:4397/GledanostPoEmisijama',
  ariannaNekonsolidovaniUrl: 'http://192.168.1.93:4398/kalendar',
  pregledAvansaUrl: 'http://192.168.1.93:44522/pregledAvansa',
  pregledSpecifikacijaUrl: 'http://192.168.1.93:44551/PregledSpecifikacija',
  uputstvaUrl: 'http://192.168.1.93:44313/api',
  videoUrl: 'http://192.168.1.93:44350/api',
  datum: '12.02.2021.',
  verzija: 'v1.01',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts